import { apiAuthCaller } from '@services/apiCaller';
import { IUserStore } from '@stores/user';
import useStores from '@stores/useStores';
import { BI_EVENTS, CATEGORY, TRACK_TYPE } from '@lib/analyticsEvents';
import { analytics } from '@lib/analytics';

const map = {
  ONBOARDING_INITIATED: 0,
  SOURCE_VIEWED: 1,
  LIVE_EVENTS_BUTTON_CLICKED: 2,
  CURL_COPIED: 3,
  ONBOARDING_COMPLETED: 4,
};

type mapKeys = keyof typeof map;
type mapValues = typeof map[mapKeys];

export default (userStore: IUserStore) => {
  const { properties, setProperties } = userStore;
  const { onboarding = map.ONBOARDING_COMPLETED } = properties || {};
  const isViewSourceTourPending = onboarding < map.SOURCE_VIEWED;
  const isLiveEventTourPending = onboarding < map.LIVE_EVENTS_BUTTON_CLICKED;
  const isSendEventTourPending = onboarding < map.CURL_COPIED;
  const isAllTabTourPending = onboarding < map.ONBOARDING_COMPLETED;

  const {
    userStore: { token },
  } = useStores();

  const apiCall = (status: mapValues) => {
    apiAuthCaller(token).put(`/userOnboardingStatus?status=${status}`);
  };

  const markViewSourceComplete = () => {
    if (isViewSourceTourPending) {
      setProperties(map.SOURCE_VIEWED);
      apiCall(map.SOURCE_VIEWED);
      analytics.track(BI_EVENTS.SAMPLE_SOURCE, TRACK_TYPE.VIEW, CATEGORY.SOURCE_ONBOARDING);
    }
  };

  const markLiveEventComplete = () => {
    if (isLiveEventTourPending) {
      setProperties(map.LIVE_EVENTS_BUTTON_CLICKED);
      apiCall(map.LIVE_EVENTS_BUTTON_CLICKED);
      analytics.track(BI_EVENTS.LIVE_EVENTS_BUTTON, TRACK_TYPE.VIEW, CATEGORY.SOURCE_ONBOARDING);
    }
  };

  const markSendEventComplete = () => {
    if (isSendEventTourPending) {
      setProperties(map.CURL_COPIED);
      apiCall(map.CURL_COPIED);
      analytics.track(BI_EVENTS.SEND_EVENT_CURL, TRACK_TYPE.VIEW, CATEGORY.SOURCE_ONBOARDING);
    }
  };

  const markAllTabComplete = () => {
    if (isAllTabTourPending) {
      setProperties(map.ONBOARDING_COMPLETED);
      apiCall(map.ONBOARDING_COMPLETED);
      analytics.track(BI_EVENTS.LIVE_EVENTS, TRACK_TYPE.VIEW, CATEGORY.SOURCE_ONBOARDING);
    }
  };

  return {
    isViewSourceTourPending,
    isLiveEventTourPending,
    isSendEventTourPending,
    isAllTabTourPending,
    markViewSourceComplete,
    markLiveEventComplete,
    markSendEventComplete,
    markAllTabComplete,
  };
};
